// Número de mesa en el paso «Mesas» del asistente.
//
// 2026-10-22 · El paso leía `m.idMesaNum`, que solo existe en el editor masivo
// (BulkEditor lo mapea a mano); las mesas del store traen `id_mesa` (API
// DtoMesaGet.Id_mesa). Resultado: todas valían 0 → cada «+» creaba otra mesa
// con el número 1 («M1», «M1»…), «−» borraba una cualquiera y al editar el
// número salía vacío.
export function mesaNumber(m) {
  return Number(m?.idMesaNum ?? m?.id_mesa) || 0;
}

/** Siguiente número libre en una zona (máximo + 1). */
export function nextMesaNumber(mesasDeLaZona) {
  return (mesasDeLaZona || []).reduce((max, m) => Math.max(max, mesaNumber(m)), 0) + 1;
}
